"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Card_1 = tslib_1.__importDefault(require("@mui/material/Card"));
const CardContent_1 = tslib_1.__importDefault(require("@mui/material/CardContent"));
const CardContent_2 = tslib_1.__importDefault(require("@mui/material/CardContent"));
const CardHeader_1 = tslib_1.__importDefault(require("@mui/material/CardHeader"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const FormControlLabel_1 = tslib_1.__importDefault(require("@mui/material/FormControlLabel"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const Switch_1 = tslib_1.__importDefault(require("@mui/material/Switch"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const ButtonPrimaryAction_1 = tslib_1.__importDefault(require("../ButtonPrimaryAction"));
const Link_1 = require("../Link");
const styles_1 = require("@mui/material/styles");
const BetaButton = (props) => {
    const { title, content, backToCurrent, defaultSwitch } = props;
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const [open, setOpen] = react_1.default.useState(false);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: (e) => handleClick(e) }, "Beta"),
        react_1.default.createElement(Popover_1.default, { open: open, anchorEl: anchorEl, anchorOrigin: { vertical: "bottom", horizontal: "left" }, onClose: () => setOpen(false) },
            react_1.default.createElement(Card_1.default, null,
                react_1.default.createElement(CardHeader_1.default, { role: "heading", title: title, titleTypographyProps: { variant: "h6", fontWeight: "bold" } }),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(CardContent_2.default, null,
                    react_1.default.createElement(Typography_1.default, { variant: "body1" }, content),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(Link_1.Link, { color: "secondary", variant: "body1", ...backToCurrent })),
                    defaultSwitch && (react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Switch_1.default, { checked: defaultSwitch.checked, onChange: (e, value) => defaultSwitch.onChange(value) }), label: react_1.default.createElement(Typography_1.default, { variant: "body1" }, defaultSwitch.label) }))),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(StyledCardActions, null,
                    react_1.default.createElement(ButtonPrimaryAction_1.default, { variant: "contained", color: "secondary", onClick: () => setOpen(false) }, "OK"))))));
};
const StyledCardActions = (0, styles_1.styled)(CardContent_1.default)(({ theme }) => ({
    display: "flex",
    flexDirection: "row-reverse",
    padding: theme.spacing(1),
    "&:last-child": {
        paddingBottom: theme.spacing(1)
    }
}));
exports.default = BetaButton;
